import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function NotFound() {
  return (
    <main className="relative min-h-[100svh] overflow-hidden bg-solidor text-white">
      <div className="flex min-h-[100svh] flex-col items-center justify-center px-5 text-center">
        <motion.p
          className="font-mono text-[10px] uppercase tracking-[0.45em] text-white/50"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          PAGE NOT FOUND
        </motion.p>

        <motion.h1
          className="mt-5 text-[110px] sm:text-[170px] lg:text-[220px] font-light leading-none tracking-[-0.07em]"
          initial={{ opacity: 0, y: 25 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.1 }}
        >
          404
        </motion.h1>

        <motion.p
          className="mt-5 max-w-md text-sm sm:text-base font-light leading-relaxed text-white/60"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.35 }}
        >
          The page you are looking for does not exist or has been moved.
        </motion.p>

        <motion.div
          className="mt-10"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.55 }}
        >
          <Link
            to="/"
            className="group inline-flex items-center gap-4 font-mono text-[10px] uppercase tracking-[0.35em]"
          >
            <span className="border-b border-white/50 pb-1 transition-opacity duration-300 group-hover:opacity-50">
              BACK TO HOME
            </span>

            <span
              aria-hidden
              className="transition-transform duration-500 group-hover:translate-x-2"
            >
              →
            </span>
          </Link>
        </motion.div>
      </div>
    </main>
  );
}
